import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProximasConsultasComponent } from './proximas-consultas.component';


const routes: Routes = [
  { path: '', component: ProximasConsultasComponent },



];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProximasConsultasRoutingModule { }
